export enum SupportedLanguages {
	// EN = 'en',
	SR = 'sr',
}

export const DefaultLanguage = SupportedLanguages.SR;

export function getSupportedLanguages(): { label: string; value: SupportedLanguages }[] {
	return [
		// {label: SupportedLanguages.EN.toUpperCase(), value: SupportedLanguages.EN},
		{ label: SupportedLanguages.SR.toUpperCase(), value: SupportedLanguages.SR },
	];
}
